import { Select, Tag } from "antd";
import { useSalesConfigurations } from "sales/queries";
import { ISalesConfiguration } from "sales/models";
import { formatCommissionRate as formatRate } from "shared/utils/formatCommissionRate";
import "./SalesConfigurationSelector.scss";

interface SalesConfigurationSelectorProps {
  value?: string;
  onChange?: (configId: string | undefined) => void;
  size?: "small" | "middle" | "large";
}

const getDisplayLabel = (config: ISalesConfiguration) => {
  const am = config.accountManagerName || "Unknown";
  const lg = config.leadGeneratorName || "Unknown";
  const ss = config.salesSupportName || "Unknown";
  return `${am} (${formatRate(config.accountManagerCommissionRate)}) / ${lg} (${formatRate(config.leadGeneratorCommissionRate)}) / ${ss} (${formatRate(config.salesSupportCommissionRate)})`;
};

export const SalesConfigurationSelector = ({
  value,
  onChange,
  size = "large",
}: SalesConfigurationSelectorProps) => {
  const { data: configurations, isLoading } = useSalesConfigurations();

  const handleChange = (configId: string | undefined) => {
    onChange?.(configId);
  };

  const selectedConfig = configurations?.find((c) => c.id === value);

  return (
    <Select
      className="sales-configuration-selector"
      size={size}
      loading={isLoading}
      value={value || undefined}
      onChange={handleChange}
      placeholder="Select a sales configuration..."
      allowClear
      optionLabelProp="label"
      labelRender={() => {
        if (!selectedConfig) return null;
        return (
          <div className="sales-configuration-selected-tags">
            <Tag color="blue">
              AM: {selectedConfig.accountManagerName || "Unknown"} ({formatRate(selectedConfig.accountManagerCommissionRate)})
            </Tag>
            <Tag color="green">
              LG: {selectedConfig.leadGeneratorName || "Unknown"} ({formatRate(selectedConfig.leadGeneratorCommissionRate)})
            </Tag>
            <Tag color="orange">
              SS: {selectedConfig.salesSupportName || "Unknown"} ({formatRate(selectedConfig.salesSupportCommissionRate)})
            </Tag>
          </div>
        );
      }}
      options={configurations?.map((config) => ({
        value: config.id,
        label: config.displayLabel || getDisplayLabel(config),
        config,
      }))}
      optionRender={(option) => {
        const config = option.data.config as ISalesConfiguration;
        if (!config) return option.label;

        return (
          <div className="sales-configuration-option">
            <div className="sales-configuration-option__members">
              <Tag color="blue">
                AM: {config.accountManagerName || "Unknown"} ({formatRate(config.accountManagerCommissionRate)})
              </Tag>
              <Tag color="green">
                LG: {config.leadGeneratorName || "Unknown"} ({formatRate(config.leadGeneratorCommissionRate)})
              </Tag>
              <Tag color="orange">
                SS: {config.salesSupportName || "Unknown"} ({formatRate(config.salesSupportCommissionRate)})
              </Tag>
            </div>
          </div>
        );
      }}
    />
  );
};
